import React from "react";
import { container_classname } from "./new-ui/constants";
import Image from "next/image";

interface IndustryCard {
    icon: string;
    title: string;
    features: string[];
    gridItemPosition: string;
}

const industryData: IndustryCard[] = [
    {
        icon: "https://assets.gallabox.com/gb-home/ai-chatbot/real-estate-bw-icon.svg",
        title: "Real estate",
        features: [
            "Answers property feature, location, and payment plan questions.",
            "Qualifies buyers/renters by budget, location, and property type.",
            "Schedules property tours or virtual walkthroughs.",
        ],
        gridItemPosition: "md:col-start-1 md:col-end-3 md:row-start-1",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/ai-chatbot/edtech-bw-icon.svg",
        title: "EdTech",
        features: ["Answers curriculum, fee, and enrollment FAQs.", "Captures student goals and learning preferences.", "Books counseling sessions with academic advisors."],
        gridItemPosition: "md:col-start-3 md:col-end-5 md:row-start-1",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/ai-chatbot/healthcare-bw-icon.svg",
        title: "Healthcare",
        features: [
            "Provides clinic timings, treatment details, and insurance info.",
            "Pre-screens patients for symptoms and urgency.",
            "Books doctor or diagnostic appointments instantly.",
        ],
        gridItemPosition: "md:col-start-5 md:col-end-7 md:row-start-1",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/ai-chatbot/travel-bw-icon.svg",
        title: "Travel",
        features: [
            "Answers itinerary, visa, baggage, and attraction queries.",
            "Captures budget, preferred destinations, and travel dates.",
            "Schedules trip-planning consultations.",
        ],
        gridItemPosition: "md:col-start-1 md:col-end-4 md:row-start-2",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/ai-chatbot/finance-bw-icon.svg",
        title: "Finance",
        features: ["Explains loans, insurance, and eligibility criteria.", "Captures income, credit score, and purpose of request.", "Books meetings with financial advisors."],
        gridItemPosition: "md:col-start-4 md:col-end-7 md:row-start-2",
    },
];

const AiIndustryCards: React.FC = () => {
    return (
        <div className="px-5 py-16" style={{ background: "var(--Grad-7, linear-gradient(265deg, #396AFF -7.73%, #00238D 61.31%, #000 102.16%))" }}>
            <h2 className={`${container_classname} text-6xl  font-semibold pb-10 max-w-7xl  px-5 text-white`} style={{ fontFamily: "Degular Display" }}>
                AI bots for every industry
            </h2>

            <div className={`${container_classname} grid grid-cols-1  md:grid-cols-6 gap-6`} style={{ fontFamily: "Inter" }}>
                {industryData.map((industry, index) => (
                    <div key={index} className={`bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 ${industry.gridItemPosition}`}>
                        <div className="flex items-center mb-7 gap-4">
                            <Image width={60} height={60} src={industry.icon} alt={`Icon ${index}`} />
                            <h3 className="text-2xl font-semibold text-black">{industry.title}</h3>
                        </div>
                        <ul className="space-y-2">
                            {industry.features.map((feature, featureIndex) => (
                                <li key={featureIndex} className="text-md text-black leading-relaxed">
                                    {feature}
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AiIndustryCards;
